import { Link } from "@/i18n/navigation";
import Image from "next/image";

export default function BlogCard({ post }) {
  // Gerekli alanların varlığını kontrol et
  if (!post || !post.id || !post.Title) {
    return null;
  }

  // Güvenli varsayılan değerler
  const imageUrl = post.ImageUrl || "/images/dummy/blog-placeholder.png";
  const slug = post.slug || post.Title || "blog-post";
  const link = post?.Link || post?.link || "/blog";
  const title = post.Title || "Başlık yüklenemedi";
  const excerpt = post.Excerpt || "";
  const authorName = post.Author?.name || "Yazar bilgisi yok";
  const dateFormatted = post.DateFormatted || "";

  // Slug varsa /blog/{slug} formatında href oluştur
  const href = link ? link : slug || "/blog";

  return (
    <Link
      key={post.id}
      href={href}
      title={title}
      target="_blank"
      className="border-border-card mr-6 flex shrink-0 basis-[75%] flex-col items-start justify-start overflow-hidden rounded-lg border sm:basis-[38%] lg:basis-[31.6%] xl:basis-[32%]"
    >
      <div className="rounded-t-default relative aspect-[147/120] w-full xl:aspect-[5/3]">
        <Image
          src={imageUrl}
          alt={slug}
          fill
          className="rounded-t-lg object-cover"
          placeholder="blur"
          blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
          sizes="(max-width: 768px) 75vw, (max-width: 1024px) 38vw, 32vw"
          onError={(e) => {
            e.target.src = "/images/dummy/blog-placeholder.png";
          }}
        />
      </div>
      <div className="flex h-full w-full flex-col items-start justify-between space-y-[21px] p-4">
        <div className="space-y-2">
          <h3 className="text-foreground m-0 text-lg font-semibold">{title}</h3>
          {excerpt && (
            <div
              className="text-muted-subtext line-clamp-3 text-sm font-normal"
              dangerouslySetInnerHTML={{ __html: excerpt }}
            />
          )}
        </div>
        <div className="space-y-1">
          <p className="text-foreground text-base font-semibold">
            {authorName}
          </p>
          {dateFormatted && (
            <p className="text-muted-subtext text-sm font-normal">
              {dateFormatted}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
